import Ajax from 'js/utils/ajax/ajax.js';
import { ApiCustomerSystem } from 'src/interfaces/interfaces.generated';

export const newCustomerSystem = (customersystem: ApiCustomerSystem): Promise<ApiCustomerSystem> =>
  Ajax.post('/customersystems/v2', customersystem);
